import { useContext, useEffect } from 'react';
import { errorCodesNumber } from '../const/errorCodes';
import store from '../helpers/store';
import { STORE_KEYS } from '../const/store-keys';
import useExecutionMutation from '../services/execution/execution-mutation';
import { ModalOptions } from '../typings/common';
import CBRContext from '../ui/cbr/context';
import { accountIdType } from '../const/config';
var useSubmitRefundRequest = function (handleSetCurrentModal) {
    var _a;
    var config = useContext(CBRContext).config;
    var accountId = store.get(STORE_KEYS.selectedIdKey, 'session');
    var _b = useExecutionMutation({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        }
    }), requestRefundData = _b.data, isLoading = _b.isLoading, isError = _b.isError, isSuccess = _b.isSuccess, mutate = _b.mutate;
    var hasRefundBusinessError = (_a = requestRefundData === null || requestRefundData === void 0 ? void 0 : requestRefundData.businessErrors) === null || _a === void 0 ? void 0 : _a.some(function (businessError) { return businessError.code === errorCodesNumber.refundInProgress; });
    var hasStatusCodeError = (requestRefundData === null || requestRefundData === void 0 ? void 0 : requestRefundData.statusCode) === 422;
    useEffect(function () {
        if (isError) {
            handleSetCurrentModal(ModalOptions.refundError);
        }
        var isInProgress = hasRefundBusinessError && hasStatusCodeError;
        var noErrorsOrLoading = !isError && !isLoading;
        if (noErrorsOrLoading && isSuccess && !isInProgress) {
            handleSetCurrentModal(ModalOptions.success);
        }
        if (noErrorsOrLoading && isInProgress) {
            handleSetCurrentModal(ModalOptions.inProgress);
        }
    }, [
        handleSetCurrentModal,
        hasRefundBusinessError,
        hasStatusCodeError,
        isError,
        isLoading,
        isSuccess
    ]);
    return function () {
        mutate({ 'cipher.accountId': accountId, accountIdType: accountIdType }, {
            onSuccess: function () {
                store.set(STORE_KEYS.isCbrExecution, false, 'session');
            }
        });
    };
};
export default useSubmitRefundRequest;
